import {
  BottomSheet,
  BottomSheetIllustrationContent,
  TextButton,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Link, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";
import { capitalize } from "lodash";

import { useShowReferralActiveBottomSheet } from "./useShowReferralActiveBottomSheet";

export function ReferralActiveBottomSheet() {
  const { referralData, referralActiveModalState } = useShowReferralActiveBottomSheet();

  const { openArticle } = useZendeskArticle();
  const { workerReferralProgramSupportLink } = useSupportLinks();
  const handleBrowseShifts = () => {
    logEvent(APP_V2_USER_EVENTS.REFERRAL_SUCCESS_BROWSE_SHIFTS_CLICKED);
    referralActiveModalState.closeModal();
  };

  const handleFaqClick = async () => {
    logEvent(APP_V2_USER_EVENTS.REFERRAL_SUCCESS_FAQ_CLICKED);
    await openArticle(workerReferralProgramSupportLink);
  };

  if (!isDefined(referralData)) {
    return null;
  }

  const { bonusRequirementMessage, bonusValue } = referralData;

  const bonusAmountFormatted = `$${bonusValue}`;

  return (
    <BottomSheet modalState={referralActiveModalState}>
      <BottomSheetIllustrationContent
        illustrationType="pay"
        title={`Your ${bonusAmountFormatted} bonus awaits!`}
        description={`${capitalize(
          bonusRequirementMessage ?? "work your first shift"
        )} to earn ${bonusAmountFormatted} when you start your Clipboard journey!`}
      />
      <Stack alignItems="center" sx={{ pb: 4 }}>
        <TextButton LinkComponent={Link} onClick={handleFaqClick}>
          Frequently Asked Questions
        </TextButton>
      </Stack>
      <DialogFooter orientation="vertical">
        <Button fullWidth size="large" onClick={handleBrowseShifts}>
          Browse Shifts
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
